import React from "react";
import { Card } from "react-bootstrap";
import { BsCheckCircleFill } from "react-icons/bs";

export default function UserProfileCard() {
  return (
    <Card className="profile-card h-100 task-card">
      
      <Card.Header className="profile-header ">

        <div className="d-flex align-items-center">

          <div className="avatar-wrapper">

            <img
              src="/assets/img/users/user-01-1.jpg"
              alt="user"
              className="avatar-img"
            />

            <span className="verify-badge">
              <BsCheckCircleFill />
            </span>

          </div>

          <div className="ms-3">

            <h5 className="text-white mb-1">Stephan Peralt</h5>

            <div className="d-flex align-items-center">

              <span className="text-light small">
                Senior Product Designer
              </span>

              <span className="dot"></span>

              <span className="text-light small">UI/UX Design</span>

            </div>

          </div>

        </div>

      </Card.Header>

      <Card.Body>

        <div className="mb-3">
          <span className="label">Phone Number</span>
          <p className="value">+1 324 3453 545</p>
        </div>

        <div className="mb-3">
          <span className="label">Email Address</span>
          <p className="value">[email protected]</p>
        </div>

        <div className="mb-3">
          <span className="label">Report Office</span>
          <p className="value">Doglas Martini</p>
        </div>

        <div>
          <span className="label">Joined on</span>
          <p className="value">15 Jan 2024</p>
        </div>

      </Card.Body>

<style>{`

.profile-card{
border-radius:5px;
border:2px solid #e5e7eb;
}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.profile-header{
background:#1f2937;
border-radius:10px 10px 0 0;
padding:20px;
}

.avatar-wrapper{
position:relative;
}

.avatar-img{
width:60px;
height:60px;
border-radius:50%;
border:3px solid #fff;
}

.verify-badge{
position:absolute;
bottom:0;
right:0;
background:#fff;
border-radius:50%;
color:#22c55e;
font-size:16px;
}

.label{
font-size:13px;
color:#6b7280;
}

.value{
font-weight:500;
color:#111827;
margin:0;
}

.dot{
width:6px;
height:6px;
background:#ff6b2c;
border-radius:50%;
margin:0 6px;
display:inline-block;
}

@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}

`}</style>

    </Card>
  );
}